import { useEffect, useState } from "react";
import type { ListItem } from "@yushi-portfolio/api-types";

export function ListPage(props: { title: string; basePath: string; load: () => Promise<{ items: ListItem[] }> }) {
  const [items, setItems] = useState<ListItem[]>();
  const [error, setError] = useState<string>();

  useEffect(() => {
    setItems(undefined);
    props.load().then((r) => setItems(r.items), (e: Error) => setError(e.message));
  }, [props.basePath]);

  return (
    <section>
      <header className="page-head">
        <h1>{props.title}</h1>
        <a className="button primary" href={`#/${props.basePath}/new`}>
          新規作成
        </a>
      </header>
      {error && <div className="notice error">{error}</div>}
      {!items && !error && <p className="muted">読み込み中…</p>}
      {items && items.length === 0 && <p className="muted">まだありません。</p>}
      {items && items.length > 0 && (
        <div className="table-scroll">
        <table className="list">
          <thead>
            <tr>
              <th>タイトル</th>
              <th>slug</th>
              <th>状態</th>
              <th>更新</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item) => (
              <tr key={item.id}>
                <td>
                  <a href={`#/${props.basePath}/${encodeURIComponent(item.id)}`}>{item.title || "(無題)"}</a>
                </td>
                <td className="mono">{item.slug ?? "—"}</td>
                <td>{item.published ? <span className="badge published">公開中</span> : <span className="badge">未公開</span>}</td>
                <td className="muted">{item.updatedAt ? new Date(item.updatedAt).toLocaleString("ja-JP") : "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
        </div>
      )}
    </section>
  );
}
